export const ListUserFeatureAccessKey = 'LIST_USER_FEATURE_ACCESS_KEY';
export const LatestReportDatesKey = 'LATEST_REPORT_DATE_KEY';
export const BuildingsListKey = 'BUILDINGS_LIST_KEY';
export const BuildingsKey = 'BUILDINGS_KEY';
export const LastSelectedLocationFromLocalStorageKey =
    'LAST_SELECTED_LOCATION_FROM_LOCAL_STORAGE_KEY';
